import React, { useState } from 'react';

import moment from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { deleteContactFile } from '../actions/delete-contact-file';
import { getContactFileUrl } from '../actions/get-contact-file-url';

import { UiButton } from '../../ui/ui-button';

import { isTruthy } from '../../util/is-truthy';
import { confirm } from '../../widgets/confirmation-dialog';

type InputProps = {
  contactFile: ContactFile;
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    getContactFileUrl: (contactFileId: number) => dispatch(getContactFileUrl(contactFileId)),
    deleteContactFile: (contactFileId: number) => dispatch(deleteContactFile(contactFileId)),
  },
});

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const UploadedFile = connect(
  undefined,
  mapDispatchToProps,
)((props: Props) => {
  const { contactFile, actions } = props;

  const [deletingContactFileId, setDeletingContactFileId] = useState<number | null>(null);

  const handleLinkClick = (contactFileId: number) => async () => {
    const { contactFileUrl } = await actions.getContactFileUrl(contactFileId);
    if (contactFileUrl) {
      window.open(contactFileUrl, '_blank');
    }
  };

  const handleDeleteClick = (contactFileId: number) => async () => {
    if (await confirm('This will permanently delete the document from Team Engine')) {
      setDeletingContactFileId(contactFileId);
      await actions.deleteContactFile(contactFileId);
      setDeletingContactFileId(null);
    }
  };

  const { contactFileId, fileName, User, createdAt, messageId } = contactFile;

  const isInboundMessageMedia = isTruthy(messageId);

  return (
    <div className="u-spread u-padding-y" style={{ borderTop: '1px solid #e0e0e0' }}>
      <div>
        <div
          className="typo-link-secondary"
          role="presentation"
          onClick={handleLinkClick(contactFileId)}
        >
          {fileName}
        </div>
        <div className="typo-subtitle">
          {isInboundMessageMedia
            ? 'Received '
            : `Uploaded ${User ? `by ${User.firstName} ${User.lastName} ` : ''}`}
          on {moment(createdAt).format('M/D/YYYY')}
        </div>
      </div>
      <div>
        <UiButton
          className="u-margin-right-md"
          size="xs"
          variant="tertiary"
          loading={deletingContactFileId === contactFileId}
          disabled={deletingContactFileId === contactFileId || isInboundMessageMedia}
          onClick={handleDeleteClick(contactFileId)}
        >
          {deletingContactFileId === contactFileId ? 'Deleting' : 'Delete'}
        </UiButton>
        <UiButton
          size="xs"
          variant="tertiary"
          loading={deletingContactFileId === contactFileId}
          disabled={deletingContactFileId === contactFileId}
          onClick={handleLinkClick(contactFileId)}
        >
          Download
        </UiButton>
      </div>
    </div>
  );
});
